import { render, staticRenderFns } from "./TransfersStatisticsTable.vue?vue&type=template&id=6401a915&scoped=true"
import script from "./TransfersStatisticsTable.vue?vue&type=script&lang=js"
export * from "./TransfersStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./TransfersStatisticsTable.vue?vue&type=style&index=0&id=6401a915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401a915",
  null
  
)

export default component.exports